import React, { FC, ReactElement } from 'react'
import styles from './FeedFooter.module.css'
import classNames from 'classnames'
import Link from '@/components/link'

const FeedFooter: FC<{ className?: string; href: string }> = (props): ReactElement => {
	return (
		<div className={classNames({ [(props?.className as any)]: !!props?.className }, styles.root)}>
			<Link href={props.href} className={classNames(styles.viewAll, 'text-md', 'semibold')}>
				View All
			</Link>
		</div>
	)
}

export default FeedFooter
